interface SidebarItemProps {
  children: React.ReactNode
  active?: boolean
  href?: string
}

export default function SidebarItem({
 children, active, href 
}: SidebarItemProps) {
  const baseClasses = "flex items-center gap-3 px-3 py-2 text-sm font-semibold leading-6"
  const activeClasses = active ? "bg-zinc-100 text-zinc-900" : "text-zinc-700 hover:bg-zinc-50 hover:text-zinc-900"
  const className = `${baseClasses} ${activeClasses}`
  
  if (href) {
    return (
      <a href={href} className={className}>
        {children}
      </a>
    )
  }
  
  return (
    <div className={className}>
      {children}
    </div>
  )
} 